import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: 'always',
    },
    queries: {
      networkMode: 'always',
      refetchOnWindowFocus: import.meta.env.PROD,
      retry: 1,
    },
  },
});

export default queryClient;
